import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppEnv } from './app/core/constants/app.constant';
// import '@okta/okta-auth-js/polyfill';

if (environment.name !== AppEnv.Local) {
 // enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
